/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function(){
  var color='',size='',material='';
  $('[data-option-position=1]').click(function(){
    color = $(this).val();
    if($('[data-option-position=2]').length > 0){
      $('[data-option-position=2]').parent().removeClass('soldout_v2');
      $('[data-option-position=2]').removeClass('soldout_v2-variant')
      $('[data-option-position=2]').each(function(){
        var  $size = $(this);
        size = $(this).val();
        if($('[data-option-position=3]').length > 0){
          $('[data-option-position=3]').parent().removeClass('soldout_v2');
          $('[data-option-position=3]').removeClass('soldout_v2-variant')
          $('[data-option-position=3]').each(function(){
            material = $(this).val();
            var  $material = $(this);
            $('.hidden-variant-select option').each(function(){
              if($(this).attr('data-title') == color+' / '+size+' / '+material && $(this).attr('disabled') == 'disabled'){
                $material.addClass('soldout_v2-variant').parent().addClass('soldout_v2');
              }
            })
          })
        }
        else{
          $('.hidden-variant-select option').each(function(){
            if($(this).attr('data-title') == color+' / '+size && $(this).attr('disabled') == 'disabled'){
              $size.addClass('soldout_v2-variant').parent().addClass('soldout_v2');
            }
          })
        }
      })
      if($('[data-option-position=2]:checked').hasClass('soldout_v2-variant')){
        $("[data-option-position=2]:not(.soldout_v2-variant)").first().click();
      }
      if($('[data-option-position=3]:checked').hasClass('soldout_v2-variant')){
        $("[data-option-position=3]:not(.soldout_v2-variant)").first().click();
      }
    }
  })
    $('[data-option-position=2]').click(function(){
    size = $(this).val();
    if($('[data-option-position=1]').length > 1){
      $('[data-option-position=1]').parent().removeClass('color-soldout_v2');
      $('[data-option-position=1]').removeClass('color-soldout_v2-variant')
      $('[data-option-position=1]').each(function(){
        var  $color = $(this);
        color = $(this).val();
        if($('[data-option-position=3]').length > 0){
          $('[data-option-position=3]').parent().removeClass('soldout_v2');
          $('[data-option-position=3]').removeClass('soldout_v2-variant')
          $('[data-option-position=3]').each(function(){
            material = $(this).val();
            var  $material = $(this);
            $('.hidden-variant-select option').each(function(){
              if($(this).attr('data-title') == color+' / '+size+' / '+material && $(this).attr('disabled') == 'disabled'){
                $material.addClass('soldout_v2-variant').parent().addClass('soldout_v2');
              }
            })
          })
        }
        else{
          $('.hidden-variant-select option').each(function(){
            if($(this).attr('data-title') == color+' / '+size && $(this).attr('disabled') == 'disabled'){
              $color.addClass('color-soldout_v2-variant').parent().addClass('color-soldout_v2');
            }
          })
        }
      })
      if($('[data-option-position=1]:checked').hasClass('color-soldout_v2-variant')){
        $("[data-option-position=1]:not(.color-soldout_v2-variant)").first().click();
      }
      if($('[data-option-position=3]:checked').hasClass('soldout_v2-variant')){
        $("[data-option-position=3]:not(.soldout_v2-variant)").first().click();
      }
    }
  })
    $('[data-option-position=3]').click(function(){
      material = $(this).val();
      $('[data-option-position=1]').parent().removeClass('color-soldout_v2');
      $('[data-option-position=1]').removeClass('color-soldout_v2-variant')
      $('[data-option-position=1]').each(function(){
        var  $color = $(this);
        color = $(this).val();
        if($('[data-option-position=2]').length > 0){
          $('[data-option-position=2]').parent().removeClass('soldout_v2');
          $('[data-option-position=2]').removeClass('soldout_v2-variant')
          $('[data-option-position=2]').each(function(){
            size = $(this).val();
            var  $size = $(this);
            $('.hidden-variant-select option').each(function(){
              if($(this).attr('data-title') == color+' / '+size+' / '+material && $(this).attr('disabled') == 'disabled'){
                $size.addClass('soldout_v2-variant').parent().addClass('soldout_v2');
              }
            })
          })
        }
        else{
          $('.hidden-variant-select option').each(function(){
            if($(this).attr('data-title') == color+' / '+size && $(this).attr('disabled') == 'disabled'){
              $color.addClass('color-soldout_v2-variant').parent().addClass('color-soldout_v2');
            }
          })
        }
      })
      if($('[data-option-position=1]:checked').hasClass('color-soldout_v2-variant')){
        $("[data-option-position=1]:not(.color-soldout_v2-variant)").first().click();
      }
      if($('[data-option-position=2]:checked').hasClass('soldout_v2-variant')){
        $("[data-option-position=2]:not(.soldout_v2-variant)").first().click();
      }
    })
    $('[data-option-position=1]:checked').click();
    $('[data-option-position=2]:checked').click();
    $('[data-option-position=3]:checked').click();
})